import { render, staticRenderFns } from "./mainComponent.vue?vue&type=template&id=ef4da1a2&scoped=true"
import script from "./mainComponent.vue?vue&type=script&lang=js"
export * from "./mainComponent.vue?vue&type=script&lang=js"
import style0 from "./mainComponent.vue?vue&type=style&index=0&id=ef4da1a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4da1a2",
  null
  
)

export default component.exports